const TOKEN_KEY = "im_admin_token";
const SESSION_KEY = "im_admin_session";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || "";
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function removeToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export function getSession() {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

export function setSession(session) {
  if (!session) {
    localStorage.removeItem(SESSION_KEY);
    return;
  }
  localStorage.setItem(
    SESSION_KEY,
    JSON.stringify({
      userInfo: session.userInfo || {},
      menus: session.menus || [],
      permissions: session.permissions || [],
    })
  );
}

export function removeSession() {
  localStorage.removeItem(SESSION_KEY);
}

export function clearAuth() {
  removeToken();
  removeSession();
}
